import { defaultAnchorSpec, type AnchorSpec } from '@ar-suite/core'
import type { ProceduralEarringOptions } from './procedural'

export interface ProceduralEarringProduct {
  id: string
  name: string
  procedural: Partial<ProceduralEarringOptions>
  anchor: AnchorSpec
}

function spec(patch: Partial<AnchorSpec> = {}): AnchorSpec {
  const s = defaultAnchorSpec('earring')
  s.unitScale = 1 // procedural models are already in cm
  s.offset = [0, -0.3, 0] // hang from just below the lobe landmark
  return Object.assign(s, patch)
}

export const PROCEDURAL_EARRINGS: ProceduralEarringProduct[] = [
  {
    id: 'ear-pearl-drop',
    name: 'Pearl drop · Gold',
    procedural: { style: 'drop', metal: 0xd4a94a, accent: 0xf6f1e7 },
    anchor: spec({ earring: { dangle: true, bothEars: true, lengthCm: 2.0 } }),
  },
  {
    id: 'ear-hoop-silver',
    name: 'Hoop · Silver',
    procedural: { style: 'hoop', metal: 0xc9ccd4 },
    anchor: spec({ earring: { dangle: true, bothEars: true, lengthCm: 1.1, damping: 5 } }),
  },
  {
    id: 'ear-jhumka-gold',
    name: 'Jhumka · Gold',
    procedural: { style: 'jhumka', metal: 0xd4a94a, accent: 0x2e7d5b, size: 1.25 },
    anchor: spec({ offset: [0, -0.15, 0], earring: { dangle: true, bothEars: true, lengthCm: 1.6 } }),
  },
  {
    id: 'ear-stud-pearl',
    name: 'Stud · Pearl',
    procedural: { style: 'stud', metal: 0xd4a94a, accent: 0xf6f1e7 },
    anchor: spec({ offset: [0, -0.2, 0.15], earring: { dangle: false, bothEars: true } }),
  },
]
